import React from "react";

import PropTypes from "prop-types";

import "./faq-card.css";

const FaqCard = (props) => {
  return (
    <div className="faq-card-container">
      <h5 className="faq-card-text HeadingThree">{props.question}</h5>
      <span className="faq-card-text1">{props.answer}</span>
    </div>
  );
};

FaqCard.defaultProps = {
  answer: "Dithering can make the image look nicer.",
  question: "Dithering?",
};

FaqCard.propTypes = {
  answer: PropTypes.string,
  question: PropTypes.string,
};

export default FaqCard;
